import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from '@/i18n/translations';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { NotificationsSettingsClient } from './-components/NotificationsSettingsClient';

export const Route = createFileRoute('/_authed/settings/notifications/')({
  component: SettingsNotificationsPage,
});

function SettingsNotificationsPage() {
  const t = useTranslations('Settings');
  const query = useQuery({
    ...identityKeys.notificationPreferences(),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title={t('notifications.errorTitle')}
        message={t('notifications.loadError')}
      />
    );
  }
  if (query.isLoading) return null;
  return <NotificationsSettingsClient />;
}
